export default __webpack_public_path__ + "static/media/weekly-thumb1.cf0dee51.png";